import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from './material.module';
import { CustomDatePipe } from "../pipes/custom-date.pipe";
import {ErrorMessagePipe} from "../pipes/error-message.pipe";
import {IntegrationTypePipe} from "../pipes/integration-type.pipe";

const sharedModules: any[] = [
  CommonModule,
  FormsModule,
  HttpClientModule,
  MaterialModule
];

@NgModule({
  declarations: [
    CustomDatePipe,
    ErrorMessagePipe,
    IntegrationTypePipe
  ],
  imports: sharedModules,
  exports: [...sharedModules, CustomDatePipe, ErrorMessagePipe, IntegrationTypePipe],
})

export class SharedModule { }
